<div class="table-scroll-x" #table>
  <table
    mat-table
    [dataSource]="isLoading() ? skeletonRows() : datas()!"
    cdkDropList
    multiTemplateDataRows
    cdkDropListOrientation="horizontal"
    cdkDropListLockAxis="x"
    (cdkDropListDropped)="drop($event)"
  >
    @for (column of columns(); track $index) {
      @switch (column) {
        @case ('checkbox') {
          <ng-container matColumnDef="checkbox" [sticky]="true">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="checkbox">
                  <kin-skeleton [height]="1.5" [width]="13.75" />
                </div>
              } @else {
                <div class="checkbox">
                  @let id = row['id'];
                  @let isSelect = row['checkbox'];
                  <input
                    type="checkbox"
                    [id]="id"
                    [checked]="isSelect"
                    (click)="elementChecked.emit(id)"
                  />
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('title') {
          <ng-container matColumnDef="title" [sticky]="true" [stickyEnd]="$last">
            <th
              app-column-header
              title="title"
              column="title"
              cdkDragDisabled
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="title">
                  <div class="thumbnail"></div>
                  <kin-skeleton [height]="1.5" [width]="13.75" />
                </div>
              } @else {
                @let id = row['id'];
                @let title = row[column];
                @let status = row['status'];
                @let isLocked = status === 'reject';
                <div class="title" [routerLink]="[id]">
                  <div class="thumbnail" [ngClass]="status">
                    @if (isLocked) {
                      <span class="locked"><kin-icon name="lock" [size]="16" /></span>
                    }
                    <img [src]="title.thumbnail" [alt]="title + ' thumbnail'" />
                  </div>
                  <h3>{{ title.name }}</h3>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('sport') {
          <ng-container matColumnDef="sport" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="sport"
              column="sport"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <kin-skeleton shape="circle" [height]="2" [width]="2" />
              } @else if (!isLoading() && row[column]) {
                <kin-icon [name]="row[column]" />
              } @else {
                -
              }
            </td>
          </ng-container>
        }
        @case ('country') {
          <ng-container matColumnDef="country" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="country"
              column="country"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div style="display: flex; gap: 8px">
                  <kin-skeleton [height]="1" [width]="1.25" />
                  <kin-skeleton [height]="1" [width]="6" />
                </div>
              } @else {
                <app-country-cell [country]="row['country']" />
              }
            </td>
          </ng-container>
        }
        @case ('duration') {
          <ng-container matColumnDef="duration" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="duration"
              column="duration"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill">
                  <p>{{ row['duration'] / 60 | number: '1.0-0' }} min</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('mode') {
          <ng-container matColumnDef="mode" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="mode"
              column="mode"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else if (row['mode']) {
                <div class="pill">
                  <p>{{ row['mode'] | uppercase }}</p>
                </div>
              } @else {
                -
              }
            </td>
          </ng-container>
        }
        @case ('distance') {
          <ng-container matColumnDef="distance" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="distance"
              column="distance"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill">
                  <p>{{ row['distance'] | distance: settingService.unit() : 'base' }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('slope') {
          <ng-container matColumnDef="slope" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="slope"
              column="slope"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill">
                  <p>{{ row['slope'] | distance: settingService.unit() : 'base' }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('level') {
          <ng-container matColumnDef="level" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="level"
              column="level"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="difficulty">
                  <kin-skeleton shape="circle" [height]="20" unit="px" />
                  <kin-skeleton [height]="1" [width]="3" />
                </div>
              } @else if (!isLoading() && row['level']) {
                @let level = row['level'];
                <div class="difficulty">
                  <span class="dot" [ngClass]="level"></span>
                  <p>{{ level }}</p>
                </div>
              } @else {
                -
              }
            </td>
          </ng-container>
        }
        @case ('status') {
          <ng-container matColumnDef="status" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="status"
              column="status"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <kin-skeleton [height]="1" [width]="6" />
              } @else {
                <app-chip
                  [text]="row['status']"
                  [icon]="row['status'] === 'private' ? 'lock' : 'language'"
                  [borderColor]="colorService.neutral900()"
                  [backgroundColor]="
                    row['status'] === 'private'
                      ? colorService.neutral900()
                      : colorService.backgroundColor()
                  "
                  [color]="
                    row['status'] === 'private'
                      ? colorService.neutral100()
                      : colorService.neutral900()
                  "
                />
              }
            </td>
          </ng-container>
        }
        @case ('sessions') {
          <ng-container matColumnDef="sessions" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="sessions"
              column="sessions"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" shape="circle" />
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill counter-pill">
                  @let sessionsCompletedCount = row['sessions'];
                  @let haveSessionsCompleted = row['sessions'] > 0;
                  <kin-icon [color]="colorService.neutral300()" name="completed_flag" />
                  <p>{{ haveSessionsCompleted ? sessionsCompletedCount : '-' }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('comments') {
          <ng-container matColumnDef="comments" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="comments"
              column="comments"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" shape="circle" />
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill counter-pill">
                  @let CommentCount = row['comments'];
                  @let hasComment = CommentCount !== 0;
                  <kin-icon [color]="colorService.neutral300()" name="comment" />
                  <p>{{ hasComment ? row['comments'] : '-' }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('likes') {
          <ng-container matColumnDef="likes" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="likes"
              column="likes"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" shape="circle" />
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill counter-pill">
                  @let likeCount = row['likes'];
                  @let hasLike = likeCount !== 0;
                  <kin-icon
                    [color]="hasLike ? colorService.brandPrimary() : colorService.neutral300()"
                    [name]="hasLike ? 'like_fill' : 'like_mixed'"
                  />
                  <p>{{ hasLike ? likeCount : '-' }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('upload') {
          <ng-container matColumnDef="upload" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="upload"
              column="upload"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="pill">
                  <kin-skeleton [height]="1" shape="circle" />
                  <kin-skeleton [height]="1" [width]="2" />
                </div>
              } @else {
                <div class="pill counter-pill">
                  <kin-icon [color]="colorService.neutral300()" name="agenda" />
                  <p>{{ row['upload'] | date: settingService.dateDisplay() }}</p>
                </div>
              }
            </td>
          </ng-container>
        }
        @case ('labels') {
          <ng-container matColumnDef="labels" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              title="labels"
              column="labels"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <kin-skeleton [height]="1" [width]="2" />
                <kin-skeleton [height]="1" [width]="4" />
              } @else {
                <app-labels-cell [labels]="row['labels']" />
              }
            </td>
          </ng-container>
        }
        @case ('actions') {
          <ng-container matColumnDef="actions" [sticky]="$first" [stickyEnd]="$last">
            <th mat-header-cell *matHeaderCellDef>
              <div class="actions-header">
                <p>{{ 'table.columns.actions' | translate }}</p>
              </div>
            </th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <div class="actions-container">
                  <kin-skeleton shape="circle" [height]="2.7" [width]="2.7" />
                  <kin-skeleton shape="circle" [height]="2.7" [width]="2.7" />
                </div>
              } @else {
                <div class="actions-container">
                  @for (action of actions(); track $index) {
                    <button class="action">
                      <kin-icon [color]="colorService.textColor()" [name]="action" />
                    </button>
                  }
                </div>
              }
            </td>
          </ng-container>
        }
        @default {
          <ng-container [matColumnDef]="column" [sticky]="$first" [stickyEnd]="$last">
            <th
              app-column-header
              [title]="column"
              [column]="column"
              *matHeaderCellDef
              (cdkDragEnded)="refreshSticky()"
            ></th>
            <td mat-cell *matCellDef="let row">
              @if (isLoading()) {
                <kin-skeleton [height]="1" [width]="3" />
              } @else {
                {{ row[column] }}
              }
            </td>
          </ng-container>
        }
      }
    }
    <tr mat-header-row *matHeaderRowDef="columns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns()"></tr>
  </table>
</div>

<button
  type="button"
  class="columns-menu-trigger"
  [class.open]="columnsMenuOpen()"
  [cdkMenuTriggerFor]="columnsMenuTpl"
  [cdkMenuPosition]="columnsMenuPositions"
  (cdkMenuOpened)="columnsMenuOpen.set(true)"
  (cdkMenuClosed)="columnsMenuOpen.set(false)"
>
  <kin-icon name="filter" [size]="20" [color]="colorService.neutral500()" />
</button>

<ng-template #columnsMenuTpl>
  <app-column-visibility-menu />
</ng-template>
